export default "__VITE_ASSET__DigWHZgL__"